<template>
	<div id="modal-delete-project" class="modal-new hidden">
		<span class="title">Delete Project</span>
		<p class="description">
			Deleting a project is irreversible. Are you sure you want to delete
			<span v-if="isCurrentOpenProject" class="current-open">the currently open</span>
			project "
			<span>{{ projectSettings ? projectSettings.name : "" }}</span>
			"?
		</p>
		<div class="buttons-continer">
			<button
				type="button"
				class="modal-btn --primary --delete"
				:class="{ '--disabled': disableButtons }"
				:disabled="disableButtons"
				@click="onDelete"
			>
				Delete
			</button>
			<button
				type="button"
				class="modal-btn --cancel"
				:class="{ '--disabled': disableButtons }"
				:disabled="disableButtons"
				@click="onCancel"
			>
				Cancel
			</button>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";

export default {
	data() {
		return {
			projectName: null,
			disableButtons: false,
		};
	},
	computed: {
		...mapState("Projects", ["projectSettings", "project"]),
		isCurrentOpenProject() {
			return this.projectSettings.id == this.project.id;
		},
	},
	methods: {
		async onDelete() {
			if (this.disableButtons) return;

			if (this.projectSettings.id == this.project.id) {
				this.disableButtons = true;
				await this.$store.dispatch("Projects/deleteProject", {
					project_id: this.projectSettings.id,
				});
                location.replace("/");
            } else {
                this.onCancel();
                if (this.projectSettings.id == this.$store.state.Projects.modalSelectedProject) {
                    this.$store.dispatch("Projects/setModalSelectedProject", null);
                }

                this.$store.dispatch("Projects/deleteProject", {
                    project_id: this.projectSettings.id,
                });
            }
        },
		onCancel() {
			if (this.disableButtons) return;
			document.querySelector("#modal-delete-project").classList.toggle("hidden");
			document.querySelector("#modal-delete-project").classList.toggle("fadeInDownModal");
			document.querySelector("#project-selector-modal").classList.toggle("hidden");
			document.querySelector("#project-selector-modal").classList.toggle("fadeInDownModal");
		},
	},
};
</script>

<style></style>
